import { Link, useNavigate, useParams } from 'react-router-dom';
import { useSite } from '../data/SiteContext';

export default function Cruises() {
  const navigate = useNavigate();
  const { cruises, loading } = useSite();

  if (!cruises.length) {
    return <div className="wrap" style={{ paddingTop:80, paddingBottom:120, textAlign:'center', color:'#5a726f' }}>
      {loading ? 'Loading…' : 'No cruises are listed at the moment.'}
    </div>;
  }

  return (
    <div className="wrap" style={{ paddingTop:40, paddingBottom:72 }}>
      <div className="kicker">Cruises</div>
      <h1 className="page-h1">Wake up somewhere new.</h1>
      <p className="page-sub">{cruises.length} ways to sail — from a week in the Caribbean to a full circumnavigation.</p>
      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(320px,1fr))', gap:24 }}>
        {cruises.map(c => (
          <div key={c.id} className="card-cool lift" onClick={() => navigate('/cruises/' + c.id)}
            style={{ cursor:'pointer', borderRadius:24, overflow:'hidden', display:'flex', flexDirection:'column', boxShadow:'0 12px 30px rgba(16,90,90,0.12)' }}>
            <div style={{ position:'relative', height:210 }}>
              <div className="bgimg" style={{ backgroundImage:`url(${c.img})` }}></div>
              {c.nights && <div style={{ position:'absolute', top:14, left:14, padding:'6px 12px', borderRadius:100, background:'rgba(255,255,255,0.9)', color:'#0c2b2f', fontSize:11.5, fontWeight:800 }}>{c.nights}</div>}
            </div>
            <div style={{ padding:20, display:'flex', flexDirection:'column', flex:1 }}>
              <div className="serif" style={{ fontSize:24, marginBottom:8 }}>{c.name}</div>
              <p style={{ fontSize:14.5, lineHeight:1.6, color:'#5a726f', margin:'0 0 14px', flex:1 }}>{c.desc}</p>
              <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between' }}>
                <span style={{ fontWeight:800, fontSize:17 }}>{c.from ? `from $${c.from.toLocaleString('en-US')}` : 'price on request'}</span>
                <span style={{ fontSize:13, fontWeight:700, color:'#0e8a9c' }}>Read more →</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function CruiseDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { cruises, loading, contact } = useSite();
  const c = cruises.find(x => String(x.id) === id);

  if (!c) {
    return (
      <div className="wrap" style={{ paddingTop:80, paddingBottom:120, textAlign:'center', color:'#5a726f' }}>
        {loading ? 'Loading…' : <>We couldn't find that cruise. <Link to="/cruises" style={{ color:'#0e8a9c', fontWeight:700 }}>See all cruises</Link></>}
      </div>
    );
  }

  const ports = (c.ports || '').split(/[·,]/).map(p => p.trim()).filter(Boolean);
  const others = cruises.filter(x => x.id !== c.id).slice(0, 3);
  const enquiry = `${contact.waLink}?text=${encodeURIComponent(`Hi! I'd like to know more about ${c.name}.`)}`;

  return (
    <div>
      <section style={{ position:'relative', minHeight:'clamp(320px,45vh,460px)', display:'flex', alignItems:'flex-end', overflow:'hidden' }}>
        <div className="cover"><div className="bgimg" style={{ backgroundImage:`url(${c.img})` }}></div></div>
        <div className="cover" style={{ background:'linear-gradient(180deg,rgba(6,40,45,0.15),rgba(6,40,45,0.75))' }}></div>
        <div style={{ position:'relative', maxWidth:1240, margin:'0 auto', padding:'0 24px 40px', width:'100%', color:'#fff' }}>
          <span onClick={() => navigate('/cruises')} style={{ cursor:'pointer', color:'rgba(255,255,255,0.9)', fontWeight:700, fontSize:14 }}>← All cruises</span>
          <div style={{ display:'inline-block', margin:'14px 0 8px', padding:'6px 14px', borderRadius:100, background:'rgba(255,255,255,0.2)', border:'1px solid rgba(255,255,255,0.4)', fontSize:12.5, fontWeight:700 }}>
            {[c.area, c.nights].filter(Boolean).join(' · ')}
          </div>
          <h1 className="serif" style={{ fontSize:'clamp(30px,5vw,54px)', margin:0, letterSpacing:'-0.5px', lineHeight:1.1 }}>{c.name}</h1>
        </div>
      </section>

      <div style={{ maxWidth:1240, margin:'0 auto', padding:'40px 24px 72px', display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(300px,1fr))', gap:40 }}>
        <div>
          {c.body
            ? c.body.split('\n\n').map((para, i) => (
                <p key={i} style={{ fontSize:16.5, lineHeight:1.75, color:'#0c2b2f', margin:i === 0 ? '0 0 16px' : '0 0 16px' }}>{para}</p>
              ))
            : <p style={{ fontSize:16.5, lineHeight:1.7, color:'#0c2b2f' }}>{c.desc}</p>}

          {ports.length > 0 && (
            <>
              <h3 className="serif" style={{ fontSize:22, margin:'30px 0 6px' }}>Typical ports</h3>
              <p style={{ fontSize:14, color:'#5a726f', margin:'0 0 14px' }}>Itineraries vary by ship and sailing date — these are the ports these routes usually call at.</p>
              <div style={{ display:'flex', flexWrap:'wrap', gap:9 }}>
                {ports.map(p => (
                  <span key={p} className="card" style={{ padding:'9px 15px', borderRadius:100, fontWeight:700, fontSize:13.5 }}>{p}</span>
                ))}
              </div>
            </>
          )}

          {others.length > 0 && (
            <>
              <h3 className="serif" style={{ fontSize:22, margin:'34px 0 14px' }}>Other ways to sail</h3>
              <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(200px,1fr))', gap:14 }}>
                {others.map(o => (
                  <Link key={o.id} to={'/cruises/' + o.id} className="card lift" style={{ display:'block', borderRadius:16, overflow:'hidden', color:'inherit' }}>
                    <div style={{ height:100 }}><div className="bgimg" style={{ backgroundImage:`url(${o.img})` }}></div></div>
                    <div style={{ padding:12 }}>
                      <div style={{ fontWeight:700, fontSize:14, lineHeight:1.3 }}>{o.name}</div>
                      <div style={{ fontSize:12.5, color:'#5a726f', marginTop:3 }}>{o.from ? `from $${o.from.toLocaleString('en-US')}` : 'price on request'}</div>
                    </div>
                  </Link>
                ))}
              </div>
            </>
          )}
        </div>

        <div>
          <div className="card" style={{ position:'sticky', top:100, padding:26, borderRadius:24, boxShadow:'0 16px 40px rgba(16,90,90,0.14)' }}>
            {c.from ? (
              <>
                <div style={{ fontSize:13, color:'#5a726f', fontWeight:600 }}>Cruises from</div>
                <div className="serif" style={{ fontSize:42, color:'#0e8a9c', lineHeight:1, margin:'2px 0 2px' }}>${c.from.toLocaleString('en-US')}</div>
                <div style={{ fontSize:13, color:'#5a726f', marginBottom:18 }}>per person{c.nights ? ` · ${c.nights}` : ''}</div>
              </>
            ) : (
              <>
                <div className="serif" style={{ fontSize:26, color:'#0e8a9c', lineHeight:1.2, margin:'2px 0 6px' }}>Price on request</div>
                <div style={{ fontSize:13, color:'#5a726f', marginBottom:18 }}>Tell us your dates{c.nights ? ` · typically ${c.nights}` : ''} — we quote each sailing individually.</div>
              </>
            )}
            <a href={enquiry} target="_blank" rel="noreferrer" className="btn btn-green" style={{ display:'block', padding:15, boxShadow:'0 10px 22px rgba(18,153,76,0.35)' }}>Enquire on WhatsApp</a>
            <a href={contact.telLink} style={{ display:'block', textAlign:'center', marginTop:10, padding:13, borderRadius:14, fontWeight:700, color:'#0e8a9c', background:'rgba(14,138,122,0.1)' }}>Or call {contact.phone}</a>
            <div style={{ fontSize:12, color:'#5a726f', marginTop:14, lineHeight:1.5 }}>
              Fares depend on the ship, the cabin grade and the sailing date. We quote flights, transfers and extras alongside the cruise so the total is clear.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
